export function getJobFormData(form, sectionIds) {
  const formData = new FormData(form);
  const data = [...formData.entries()].reduce((result, [key, value]) => {
    // TODO: could also parse arrays in the form `contact[title]` to represent a javascript object
    const isArray = key.substring(key.length - 2) === '[]';

    if (isArray) {
      const arrKey = key.substring(0, key.length - 2);

      return {
        ...result,
        [arrKey]: [...(result[arrKey] || []), value],
      };
    }

    return {
      ...result,
      [key]: value,
    };
  }, {});

  const dataWithSectionVisibility = sectionIds.reduce(
    (result, sectionId) => ({
      ...result,
      [`${sectionId}[visible]`]: isTruthyCheckboxValue(result[`${sectionId}[visible]`]),
    }),
    data,
  );

  return dataWithSectionVisibility;
}

function isTruthyCheckboxValue(value) {
  if (!value) {
    return false;
  }

  if (value.toLowerCase() === 'on') {
    return true;
  }

  if (value === '1' || value === 1) {
    return true;
  }

  if (value === 'true' || value === true) {
    return true;
  }

  return false;
}
